export const formatUSDEnsure2Digits = (amount) => {
  // formatUSD fails to format amounts less than 0.01
  // this function ensures that amounts less than 0.01 are formatted correctly. That means at least showing 1 decimal place.

  if (Number(amount) >= 0.01) {
    return formatUSD(Number(amount));
  } else {
    let number = '';
    let decimal = false;
    let digits = 0;
    for (let index = 0; index < String(amount).length; index++) {
      const currentNumber = String(amount)[index];
      number += currentNumber;
      if (currentNumber === '.') {
        decimal = true;
        continue;
      }
      if (decimal) {
        if (currentNumber !== '0') {
          digits += 1;
        }
      }
      if (digits === 1) {
        break;
      }
    }
    return `$${number}`;
  }
};

export const formatUSD = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
};

export const getCurrencySymbol = (currency) => {
  const normalized = String(currency || '').trim();
  if (!normalized) return '$';

  if (/^[A-Z]{3}$/.test(normalized)) {
    try {
      const formatter = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: normalized,
        currencyDisplay: 'narrowSymbol',
      });
      const symbol = formatter
        .format(0)
        .replace(/[\d\s.,]/g, '')
        .trim();
      if (symbol) {
        return symbol;
      }
    } catch {
      // Fall back to normalized value below
    }
  }

  return normalized;
};

export const formatTokenPrice = (amount, usdcValue) => {
  if (!amount) return '0.00';
  if (usdcValue && usdcValue < 0.01) return '0.00';

  // Convert scientific notation to decimal
  const numStr = Number(amount).toString();
  let decimalStr;

  if (numStr.includes('e')) {
    const [coefficient, exponent] = numStr.split('e');
    const exp = parseInt(exponent);
    if (exp < 0) {
      // For negative exponents, add leading zeros
      const absExp = Math.abs(exp);
      const decimalPart = coefficient.replace('.', '');
      decimalStr = '0.' + '0'.repeat(absExp - 1) + decimalPart;
    } else {
      // For positive exponents, move decimal point
      const decimalPart = coefficient.replace('.', '');
      decimalStr = decimalPart + '0'.repeat(exp);
    }
  } else {
    // Ensure we have a decimal part
    decimalStr = numStr.includes('.') ? numStr : `${numStr}.0`;
  }

  // Find the first non-zero digit in the decimal part
  const fraction = decimalStr.split('.')[1] || '';
  const firstNonZero = fraction.split('').findIndex((digit) => digit !== '0');

  if (firstNonZero === -1)
    return Number(decimalStr).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  // Add 2 more decimal places for context
  const significantDecimals = firstNonZero + 2;

  return Number(decimalStr).toLocaleString('en-US', {
    minimumFractionDigits: significantDecimals,
    maximumFractionDigits: significantDecimals,
  });
};

export const formatVets = (amount) => {
  if (amount) {
    return parseInt(amount) / 1000000000;
  } else {
    return amount;
  }
};

export const hasBalance = (amount) => {
  return amount > 0.1;
};
